import { Link, useNavigate } from 'react-router-dom';
import { ServerOff, Users } from 'lucide-react';
import { api, avatarUrl, guildIconUrl } from '../api.js';

function timeOfDay() {
  const h = new Date().getHours();
  if (h < 5) return 'Up late';
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  if (h < 22) return 'Good evening';
  return 'Up late';
}

function formatCount(n) {
  if (n == null) return '—';
  if (n >= 1000) return (n / 1000).toFixed(n >= 10_000 ? 0 : 1) + 'k';
  return String(n);
}

export default function ServerPicker({ me, setMe }) {
  const navigate = useNavigate();

  async function handleLogout() {
    await api.logout();
    setMe({ loading: false, user: null });
  }

  const name = me.user.global_name || me.user.username;
  const totals = me.totals || { guilds: me.manageable?.length || 0, members: 0 };

  return (
    <div className="app">
      <div className="topbar">
        <div className="brand">
          <img className="brand-icon" src="/soupos-icon.png" alt="" /> SoupOS
        </div>
        <div className="row" style={{ gap: '.75rem', flex: 0 }}>
          {me.isOwner && <Link to="/owner" className="btn ghost">Owner panel</Link>}
          <img className="avatar" src={avatarUrl(me.user)} alt="" />
          <span>{name}</span>
          <button className="ghost" onClick={handleLogout}>Log out</button>
        </div>
      </div>

      <div className="content">
        <div className="greeting">
          <img className="greeting-avatar" src={avatarUrl(me.user)} alt="" />
          <div>
            <div className="title">
              {timeOfDay()}, {name} 👋
              {me.isOwner && <span className="badge accent" style={{ marginLeft: 10, verticalAlign: 'middle' }}>owner</span>}
            </div>
            <div className="sub">Pick a server below to manage. {me.isOwner ? 'As bot owner you can manage every server SoupOS is installed in.' : 'You need Manage Server permission on a guild where SoupOS is installed.'}</div>
          </div>
          <div className="summary-tiles">
            <div className="tile">
              <div className="num">{totals.guilds}</div>
              <div className="lbl">{totals.guilds === 1 ? 'Server' : 'Servers'}</div>
            </div>
            <div className="tile">
              <div className="num">{formatCount(totals.members)}</div>
              <div className="lbl">Members</div>
            </div>
          </div>
        </div>

        {me.manageable?.length ? (
          <div className="server-grid">
            {me.manageable.map(g => (
              <div key={g.id} className="server-card" onClick={() => navigate(`/g/${g.id}/overview`)}>
                <div
                  className="icon"
                  style={g.icon ? { backgroundImage: `url(${guildIconUrl(g)})` } : undefined}
                >
                  {!g.icon && g.name.slice(0, 1).toUpperCase()}
                </div>
                <div className="name">{g.name}</div>
                <div className="server-stats">
                  {g.member_count != null && (
                    <span className="item"><Users size={13} strokeWidth={2} />{formatCount(g.member_count)}</span>
                  )}
                  {g.online_count != null && (
                    <span className="item"><span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--success)', display: 'inline-block', boxShadow: '0 0 6px var(--success)' }} />{formatCount(g.online_count)} online</span>
                  )}
                </div>
                {g.you_own && (
                  <div className="badges">
                    <span className="badge accent">you own</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="empty">
            <div className="ico"><ServerOff size={32} strokeWidth={1.5} /></div>
            <p>No manageable servers found.</p>
            <p className="dim">Make sure SoupOS is installed in your server and you have Manage Server permission.</p>
          </div>
        )}
      </div>
    </div>
  );
}
